import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import User from "../../../types/User"
import DateTimeListItem from "../../common/ListItems/DateTime";

export interface componentProps {
    item: User
}

const ViewItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.info')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('users.form.name')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.name || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('users.form.email')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.email || '-'}</IonNote>
            </IonItem>
            {item.meta?.lastLoginAt &&
                <DateTimeListItem label={t('users.last_login_at').toString()}
                                  dateTime={item.meta.lastLoginAt} />
            }
            <IonItem lines="full">
                <IonLabel>{t('users.form.is_admin')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.isAdmin ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('users.form.is_enabled')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.isEnabled ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ViewItemGroupInfo